import React from "react";
import PropTypes from "prop-types";

export const Placeholder = ({ text, blur }) => (
  <span style={{ filter: `blur(${blur || 0}px)` }}>{text}</span>
);

Placeholder.propTypes = {
  text: PropTypes.string.isRequired,
};
